<template>
  <div id="ClientPopup">
    <!-- <popup ref="popup" type="center" :coverClose="false"> -->
      <div class="Client" v-show="!playviedo">
        <div class="Client_text">紧急通知，用户必读</div>
        <div class="Client_notice">
          <p>首先感谢您的信任和支持！</p>
          <p>
            近期有大量用户联系客服投诉，付费后升级不了会员或无法使用，经过我们技术认真排查，发现市面上有大量的模仿我们的软件出现！导致用户在搜索我们网站的时候，进入到冒充我们的虚假网站！从而严重影响我们软件的信誉！</p>
          <p>
            现在我们技术团队连夜开发出一个电脑桌面客户端，用户只需要简单安装一次，以后只需要一键点击桌面客户端打开使用，以防上当受骗！</p>
        </div>
        <div class="Client_btn">
          <div class="btn_video" @click="openVideo">
            <img src="./img/kehudVideoIc.png" alt="">
            10秒演示视频
          </div>
          <!-- <a target="_blank" @click="Download()"
             href="http://mjimg.zhanjuzhe.cn/raw/deskapp/MJ%E4%B8%AD%E6%96%87%E7%AB%99.exe"> -->
            <div class="btn_download" @click="Download()">
              <img src="../views/img/img_icon_104.png" alt="">
              下载电脑客户端
            </div>
          <!-- </a> -->

        </div>
        <div class="download_num">已有<span>{{ today_num }}</span>位用户下载客户端，成功防止被骗</div>
        <div class="close_btn" @click="closePop_other">
          我不在乎是否被骗，无需下载客户端，点此关闭
        </div>
      </div>
    <!-- </popup> -->
    <videoDialog ref="videoDialog" v-show="playviedo" @closeVideo="playviedo=false"></videoDialog>
  </div>
</template>

<script type="text/ecmascript-6">
import popup from "@/components/Popup.vue"
import videoDialog from "@/components/VideoDialog2.vue";

export default {
  components: {videoDialog, popup},
  props: {
   
  },
  data() {
    return {
      today_num: 0,
      today_edit_num: 546315,
      playviedo:false,
      de:DESK_APP_URL,
    }
  },
  created() {
    this.totalDongHua()
    localStorage.setItem('kehuTip',JSON.stringify({time:Date.now()}))
  },
  beforeDestroy() {
  },
  methods: {
    // },
    closePop_other(){
      localStorage.setItem('kehuTip',JSON.stringify({time:Date.now()}))
      this.$store.commit('showKehuTip', false)
    },
    Download(){
      //埋点
      this.$http.post('/wap/jsstat/browser/record/', {user_id: localStorage.getItem("user_id") || 0, mod_code: "deskdown1", site_url: MAIN_URLROOT}).then(()=>{
        const link = document.createElement('a');
        // link.href = 'https://www.midjournny.cn/install/midjournny%E4%B8%AD%E6%96%87%E7%AB%99v1.0.1.exe';
        link.href = DESK_APP_URL
        link.click();
        localStorage.setItem('clientDownDate',true)
        this.$store.commit('showKehuTip', false)
      })

    },
    openVideo() {
      // this.$refs.popup.close();
      this.playviedo = true
      this.$refs.videoDialog.show()
    },
    totalDongHua() {
      let today_doc_num = this.today_edit_num;
      let step = parseInt(today_doc_num / 20);
      let timer = setInterval(() => {
        this.today_num = this.today_num + step;
        if (this.today_num > today_doc_num) {
          this.today_num = today_doc_num;
          clearInterval(timer);
        }
      }, 100)
    },
  },
};
</script>
<style scoped lang="scss">
#ClientPopup{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.Client {
  padding: 40px 30px;
  width: 550px;
  // height: 500px;
  //height: 650px;
  background-color: #ffffff;
  border-radius: 10px;

  .Client_text {
    text-align: center;
    color: #b90103;
    font-size: 28px;
    font-weight: bold;
    padding: 0 0 40px;
    border-bottom: 1px dashed #b90103;
  }

  .Client_notice {
    font-size: 16px;
    color: #333333;
    padding: 40px 0;

    p {
      line-height: 2.5;
      text-indent: 2em;
    }

    p:not(:first-child) {
      //margin-top: 15px;
    }
  }

  .Client_btn {
    display: flex;
    justify-content: space-between;

    img {
      width: 18px;
      height: 18px;
      font-size: 0;
      margin-right: 10px;
    }

    div {
      width: 230px;
      height: 50px;
      box-sizing: border-box;
      border-radius: 6px;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .btn_video {
      color: #b90103;
      background-color: #ffc1c1;
    }

    .btn_download {
      background-color: #b90103;
      color: #ffffff;
    }
  }

  .download_num {
    text-align: center;
    font-size: 16px;
    margin: 40px 0;

    span {
      color: #b90103;
      margin: 0 10px;
    }
  }

  .close_btn {
    text-align: center;
    color: #999999;
    background-color: #e3e3e3;
    border-radius: 8px;
    padding: 20px 0;
    cursor: pointer;
  }

}

/* 当屏幕高度小于1000px时应用的样式 */
@media (max-height: 800px) {
  .Client {
    padding: 20px 30px;

    .Client_text {
      padding: 0 0 20px;
    }

    .Client_notice {
      padding: 20px 0;
    }

    .download_num {
      margin: 20px 0;
    }
  }
}

/* 弹窗适应到650px高度 */

</style>